import { NavLink } from 'react-router-dom';
import { Calendar, Ellipsis, Filter, MessageCircle, Phone, type LucideIcon } from 'lucide-react';
import { tapLight } from '@/lib/haptics';

export interface TabDef {
  path: string;
  label: string;
  icon: LucideIcon;
}

/** Пять разделов — ровно как в утверждённом прототипе (вариант A, раздел 14 плана). */
export const TABS: TabDef[] = [
  { path: '/inbox', label: 'Входящие', icon: MessageCircle },
  { path: '/pipeline', label: 'Воронка', icon: Filter },
  { path: '/calls', label: 'Звонки', icon: Phone },
  { path: '/calendar', label: 'Календарь', icon: Calendar },
  { path: '/more', label: 'Ещё', icon: Ellipsis },
];

interface Props {
  /** Красные значки: путь вкладки → число. 0 и отсутствие — значка нет. */
  badges?: Partial<Record<string, number>>;
}

/**
 * Нижнее меню. Прячется при открытой клавиатуре (класс kb-open на корне,
 * см. keyboardSync + index.css), отступ снизу — safe-area.
 */
export function TabBar({ badges = {} }: Props) {
  return (
    <nav className="tabbar" aria-label="Разделы">
      {TABS.map(({ path, label, icon: Icon }) => {
        const n = badges[path] ?? 0;
        return (
          <NavLink key={path} to={path} className="tab" onClick={() => void tapLight()}>
            <Icon aria-hidden />
            {label}
            {n > 0 && (
              <span className="cnt tnum" aria-label={`${n} новых`}>
                {n > 99 ? '99+' : n}
              </span>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
